// extracted by mini-css-extract-plugin
export default {"container":"success_container__Uc3bH","transation":"success_transation__5r4Ie","status":"success_status__y8H9Z","content":"success_content__3fn6W","button":"success_button__i-Qi8"};